<template>
    <div>
        <div class="grid-box-fc">
            <div class="sp-card">
                <div class="title">库存总量</div>
                <div class="mainNumber">{{element.totalNum}}</div>
                <div class="other">
                    <div>
                        <span class="key">总入库</span>
                        <span class="value">{{element.totalEnter}}</span>
                    </div>
                    <div>
                        <span class="key">总出库</span>
                        <span class="value">{{element.totalExit}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">今日入库</div>
                <div class="mainNumber">{{element.todayEnter}}</div>
                <div class="other">
                    <div>
                        <span class="key">价值</span>
                        <span class="value">{{element.todayEnterPrice}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">今日出库</div>
                <div class="mainNumber">{{element.todayExit}}</div>
                <div class="other">
                    <div>
                        <span class="key">价值</span>
                        <span class="value">{{element.todayExitPrice}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
        </div>
        <div class="grid-box-fc" style="grid-template-columns: 1fr 1fr;">
            <div class="sp-card">
                <el-select class="sitem" size="mini" v-model="wid" style="width:180px" @change="getStockInfo()">
                    <el-option v-for="item in wareList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <div id="stock1" style="width:100%;height:340px;">
                </div>
            </div>
            <div class="sp-card">
                <el-select style="width:150px" class="sitem" @change="getSendList" v-model="cid" size="mini" placeholder="请选择" remote filterable :remote-method="getCustomerList">
                    <el-option v-for="(item,index) in customerList" :key="index" :value="item.id" :label="item.label"></el-option>
                </el-select>
                <div id="stock2" style="width:100%;height:340px;">
                </div>
            </div>
        </div>
        <div class="sp-card">
            <div style="width:100%;height:240px;">
                <el-table border size="mini" :data="sendList" max-height="240">
                    <el-table-column label="商品" prop="label" width="180px">
                        <template slot-scope="{row}">
                            <div class="uni_ellipsis">{{row.label}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="入库" prop="inStock" sortable></el-table-column>
                    <el-table-column label="出库" prop="outStock" sortable></el-table-column>
                    <el-table-column label="订货" prop="odUnit" sortable></el-table-column>
                    <el-table-column label="发货开单" prop="sendedUnit" sortable></el-table-column>
                    <el-table-column label="未开单" prop="notSendUnit" sortable></el-table-column>
                    <el-table-column label="商品库存" prop="stock" sortable></el-table-column>
                    <el-table-column label="可用库存" prop="astkUnit" sortable></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            element:{
                totalNum:0,
                totalEnter:0,
                totalExit:0,
                todayEnter:0,
                todayEnterPrice:0,
                todayExit:0,
                todayExitPrice:0,
            },
            wareList:[],
            wid:'',
            chartList:[null,null],
            isShowPage:false,
            page:0,
            sendList:[],
            cid:'',
            customerList:[],
        }
    },
    methods:{
        setResize(){
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.isShowPage = true;
            this.getInfo();
            this.getProductSendInfo();
            this.$api.listWareHouse({page:1,limit:-1}).then(res=>{
                this.wareList = res.data.data;
                if(this.wareList.length>0){
                    this.wid = this.wareList[0].id;
                    this.getStockInfo();
                }
            })
            this.getCustomerList();
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('stock'+(key+1)))
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getCustomerList:function(val){
            let obj = {
                page:1,
                limit:20,
                customer:val?val:'',
            }
            this.$api.customerlistCustomer(obj).then(res=>{
                this.customerList = [];
                res.data.data.forEach(e=>{
                    let obj = {
                        id:e.id,
                        label:`[${e.cnumber}]${e.cname}`,
                    }
                    this.customerList.push(obj);
                })
                if(this.customerList.length>0&&(!val)){
                    this.cid = this.customerList[0].id;
                    this.getSendList();
                }
            })
        },
        getSendList:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.getCustomerStockOutProduct({page:1,limit:-1,cid:this.cid,...obj}).then(res=>{
                let customerSendList = [];
                let nameList = [];
                res.data.data.data.forEach(e=>{
                    let index = nameList.indexOf(e.pname);
                    if(index>=0){
                        let item = customerSendList[index];
                        item.stkOutUnit+=e.stkOutUnit;
                        item.stkUnit+=e.stkUnit;
                    }else{
                        let obj = {
                            label:e.pname,
                            stkOutUnit:e.stkOutUnit,
                            stkUnit:e.stkUnit,
                        }
                        customerSendList.push(obj);
                        nameList.push(e.pname);
                    }
                })
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        legend: {},
                        title:{
                            text:'客户出库统计',
                            left:'left',
                        },
                        color:[
                            '#1E87F0',
                            '#FAA05A',
                        ],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '4%',
                            bottom: '15%',
                            containLabel: true
                        },
                        xAxis: { type: 'category',data:customerSendList.map(e=>e.label) },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（双）',
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                show: true,
                                xAxisIndex: [0],
                                start: 0,
                                end: 100,
                            },
                        ],
                        series: [
                            { type: 'bar',name:'出库数',data:customerSendList.map(e=>e.stkOutUnit) },
                            { type: 'bar',name:'结存数',data:customerSendList.map(e=>e.stkUnit) }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.sumRecord({page:1,limit:1,...obj}).then(res=>{
                let dd = res.data.data;
                this.element.totalEnter = dd.sum.sumin;
                this.element.totalExit = -dd.sum.sumout;
                this.element.totalNum = dd.sum.sumin+dd.sum.sumout;
            })
            
            let today = this.$common.dayformat(new Date());
            this.$api.sumRecord({start:today+" 00:00:00",end:today+" 23:59:59"}).then(res=>{
                let dd = res.data.data;
                this.element.todayEnter = dd.sum.sumin;
                this.element.todayEnterPrice = dd.sum.sumpricein;
                this.element.todayExit = -dd.sum.sumout;
                this.element.todayExitPrice = -dd.sum.sumpriceout;
            })
            
        },
        getStockInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.sumRecord({page:1,limit:-1,wid:this.wid,...obj}).then(res=>{
                let dd = res.data.data;
                let ids = [];
                let total = 0;
                let stockItemList = [];
                dd.list.forEach(e=>{
                    let count = e.in+e.out;
                    if(count>0){
                        total += count;
                        let index = ids.indexOf(e.pid);
                        if(index>=0){
                            let item  = stockItemList[index];
                            item.value += count;
                        }else{
                            ids.push(e.pid);
                            stockItemList.push({
                                name:e.pname,
                                value:count,
                            })
                        }
                    }
                })
                if(stockItemList.length>10){
                    stockItemList.sort((a,b)=>b.value-a.value);
                    let arr = stockItemList.splice(9,stockItemList.length-9);
                    let cc = 0;
                    arr.forEach(e=>{
                        cc +=e.value;
                    })
                    stockItemList.push({
                        name:'其他',
                        value:cc,
                    })
                }
                stockItemList.forEach(e=>{
                    let per = (e.value*100/total).toFixed(2);
                    e.name = per+"% "+e.name+" "+e.value;
                })
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        title:{
                            text:'仓库详情',
                            left:'left',
                        },
                        color:[
                            '#5470c6',
                            '#91cc75',
                            '#fac858',
                            '#ee6666',
                            '#73c0de',
                            '#3ba272',
                            '#fc8452',
                            '#9a60b4',
                            '#ea7ccc',
                            '#D65EF4',
                        ],
                        tooltip: {
                            trigger: "item",
                        },
                        legend: {
                            type: 'scroll',
                            orient: 'vertical',
                            left: 0,
                            top: 25,
                            bottom: 10,
                        },
                        series: [
                            {
                                type: 'pie',
                                radius: ['10%', '70%'],
                                avoidLabelOverlap: false,
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                },
                                left: '30%',
                                top:'10%',
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                labelLine: {
                                    show: false,
                                },
                                data: stockItemList,
                            }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getProductSendInfo:function(){
            let obj = {
                limit:-1,
                page:1,
                group:1,
                hide:0,
                confirmed:1,
            }
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.inStart = this.filterbox.time[0];
                obj.inEnd = this.filterbox.time[1];
            }
            this.$api.empGetProductStock(obj).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    itemList.push({
                        pid:e.pid,
                        label:e.pname,
                        astkUnit:Number.parseInt(e.astkUnit),
                        inStock:Number.parseInt(e.inStock),
                        outStock:Number.parseInt(e.outStock),
                        notSendUnit:Number.parseInt(e.notSendUnit),
                        odUnit:Number.parseInt(e.odUnit),
                        sendedUnit:Number.parseInt(e.sendedUnit),
                        stock:Number.parseInt(e.stock),
                    })
                });
                this.sendList.push(...itemList);
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.grid-box-fc{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    padding-bottom: 10px;
}
.sitem{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 11;
}
</style>